




























































import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "AppModal"
})
export default class AppModal extends Vue {
  // ===== Props ===== //
  @Prop({ default: false }) public readonly cancelDisabled?: boolean;
  @Prop({ default: false }) public readonly hideActions?: boolean;
  @Prop({ default: false }) public readonly hideCancel?: boolean;
  @Prop({ default: false }) public readonly hideConfirm?: boolean;
  @Prop({ default: false }) public readonly persistent?: boolean;
  @Prop({ default: false }) public readonly loading?: boolean;
  @Prop({ default: false }) public readonly confirmDisabled?: boolean;
  @Prop(Boolean) public readonly value!: boolean;
  @Prop({ default: "66%" }) public readonly width?: string;
  // ===== Methods ===== //
  @Emit("cancel")
  public cancel(): boolean {
    return true;
  }
  @Emit("confirm")
  public confirm(): boolean {
    return true;
  }
  public processKeydown(e: KeyboardEvent): void {
    if (e.key === "Escape") this.cancel();
  }
  // ===== Computed ===== //
  get show(): boolean {
    return this.value;
  }
}
